import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';

const accessKey = 'AKIAQ4HNV7TGTZKXMO5T';
const secretKey = '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';

const bucketName = 'viliyo-media-v3';
const s3Region = 'ap-south-1';
const storeFolder = 'viliyo';

const S3_BUCKET_BASE_URL =
  'https://viliyo-media-v3.s3.ap-south-1.amazonaws.com/';

export const generateHashForFile = (
  fileName: string,
): string => {
  const pattern = /[^a-zA-Z0-9.-]/g;

  const sanitizedFileName =
    fileName.replace(pattern, '_');

  console.log(
    '[FILE] Sanitized filename:',
    sanitizedFileName,
  );

  return sanitizedFileName;
};

const handleFileUploadToAws = async (
  creds: {
    accessKeyId: string;
    secretAccessKey: string;
  },
  params: any,
  file: File,
): Promise<string> => {
  try {
    console.log('========================================');
    console.log('[S3] Starting upload');
    console.log('========================================');

    console.log('[S3] Bucket:', params.Bucket);
    console.log('[S3] Region:', s3Region);
    console.log('[S3] Key:', params.Key);
    console.log('[S3] File name:', file.name);
    console.log('[S3] File type:', file.type);
    console.log('[S3] File size:', file.size);

    if (
      !creds.accessKeyId ||
      !creds.secretAccessKey
    ) {
      throw new Error(
        'AWS credentials are missing',
      );
    }

    const s3Client = new S3Client({
      region: s3Region,
      credentials: {
        accessKeyId:
          creds.accessKeyId.trim(),
        secretAccessKey:
          creds.secretAccessKey.trim(),
      },
    });

    const parallelUploads3 = new Upload({
      client: s3Client,

      leavePartsOnError: false,

      params: {
        ...params,
        ContentType:
          file.type ||
          'application/octet-stream',

        // Keep this only if your S3 bucket
        // allows ACLs.
        //
        // ACL: 'public-read',
      },
    });

    parallelUploads3.on(
      'httpUploadProgress',
      (progress) => {
        const percentage =
          progress.total && progress.loaded
            ? (
                (progress.loaded /
                  progress.total) *
                100
              ).toFixed(2)
            : 'N/A';

        console.log(
          `[S3] Upload progress: ${percentage}%`,
          {
            loaded: progress.loaded,
            total: progress.total,
          },
        );
      },
    );

    const result =
      await parallelUploads3.done();

    console.log('========================================');
    console.log('[S3] ✓ Upload successful');
    console.log('========================================');

    console.log('[S3] Bucket:', params.Bucket);
    console.log('[S3] Key:', params.Key);
    console.log(
      '[S3] Location:',
      result.Location,
    );
    console.log(
      '[S3] ETag:',
      result.ETag,
    );

    const uploadedUrl =
      result.Location ||
      `${S3_BUCKET_BASE_URL}${params.Key}`;

    console.log(
      '[S3] ✓ Final URL:',
      uploadedUrl,
    );

    return uploadedUrl;
  } catch (error: any) {
    console.error('========================================');
    console.error('[S3] ✗ Upload failed');
    console.error('========================================');

    console.error(
      '[S3] Error:',
      error?.message || error,
    );

    console.error(
      '[S3] Code:',
      error?.code || 'N/A',
    );

    console.error(
      '[S3] Name:',
      error?.name || 'N/A',
    );

    console.error(
      '[S3] Status:',
      error?.$metadata?.httpStatusCode ||
        error?.statusCode ||
        'N/A',
    );

    throw error;
  }
};

export async function uploadImages(
  file: File,
): Promise<string> {
  console.log('========================================');
  console.log('[UPLOAD] Starting image upload');
  console.log('========================================');

  console.log('[UPLOAD] File:', {
    name: file.name,
    type: file.type,
    size: file.size,
  });

  const fileName =
    generateHashForFile(file.name);

  const key =
    `${storeFolder}/${fileName}`;

  const target = {
    Bucket: bucketName,
    Key: key,
    Body: file,
    ContentType:
      file.type || 'image/png',

    // Uncomment ONLY if your S3 bucket
    // supports ACLs:
    //
    // ACL: 'public-read',
  };

  const creds = {
    accessKeyId: accessKey.trim(),
    secretAccessKey: secretKey.trim(),
  };

  const uploadedUrl =
    await handleFileUploadToAws(
      creds,
      target,
      file,
    );

  console.log('========================================');
  console.log(
    '[UPLOAD] ✓ Image uploaded successfully',
  );
  console.log('[UPLOAD] Key:', key);
  console.log('[UPLOAD] URL:', uploadedUrl);
  console.log('========================================');

  return uploadedUrl;
}
